import { render, staticRenderFns } from "./EdgeSetting.vue?vue&type=template&id=728ab414&scoped=true&"
import script from "./EdgeSetting.vue?vue&type=script&lang=js&"
export * from "./EdgeSetting.vue?vue&type=script&lang=js&"
import style0 from "./EdgeSetting.vue?vue&type=style&index=0&id=728ab414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ab414",
  null
  
)

export default component.exports